import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Calendar, User } from "lucide-react";

const Blog = () => {
  const posts = [
    {
      id: 9,
      image: "/10thdecember/img1.jpeg",
      title: "A Thousand Smiles: Successful IDP Camp Feeding Initiative",
      date: "December 10, 2025",
      author: "Oshoke Alasa Foundation",
      excerpt: "Our successful feeding initiative at Area 1 IDP Camp, Abuja brought smiles, food, clothing, and essential supplies to displaced families, making a real difference in their lives.",
      link: "/campaigns/thousand-smiles",
    },
    {
      id: 8,
      image: "/leeroyalty/img1.jpg",
      title: "A Day of Love, Hope & Impact at Lee Royalty Orphanage Center",
      date: "February 22, 2026",
      author: "Oshoke Alasa Foundation",
      excerpt: "The Oshoke Alasa Foundation was honored to spend time with the incredible children at Lee Royalty Orphanage Center, Benin City, sharing support, essentials, and reminding them that they are seen, valued, and deeply loved.",
      link: "/campaigns/lee-royalty-orphanage",
    },
    {
      id: 10,
      image: "/charityfaith/img1.jpeg",
      title: "Our First Visit to Charity Faith and Hope Orphanage",
      date: "April 15, 2025",
      author: "Oshoke Alasa Foundation",
      excerpt: "On Tuesday, April 15th, our team had the privilege of visiting Charity Faith and Hope Orphanage Home to spend quality time with the children and share love.",
      link: "/campaigns/charity-faith-hope",
    },
    {
      id: 11,
      image: "/gallery/img7.jpeg",
      title: "A Heartwarming Day at God's Pavilion Orphanage",
      date: "April 22, 2025",
      author: "Oshoke Alasa Foundation",
      excerpt: "We laughed, played games, shared stories, and listened to the dreams of these amazing children at Apo Waru, Abuja-FCT.",
      link: "/campaigns/gods-pavilion",
    },
    {
      id: 12,
      image: "/may8th/img1.jpeg",
      title: "Standing in the Gap at National Hospital Abuja",
      date: "May 8, 2025",
      author: "Oshoke Alasa Foundation",
      excerpt: "We paid several medical bills for patients and gave out essential items to the sick. It was a day filled with compassion, connection, and care.",
      link: "/campaigns/national-hospital",
    },
    {
      id: 13,
      image: "/shoesforall/img1.jpeg",
      title: "Shoes For All: Empowering Women Through Skills",
      date: "2025",
      author: "Oshoke Alasa Foundation",
      excerpt: "Our 3-day Footwear-Making Workshop trained young women in hands-on shoemaking skills that can change the course of their futures.",
      link: "/campaigns/shoes-for-all",
    },
    {
      id: 14,
      image: "/policeappreciation/img1.jpeg",
      title: "Honoring Our Police Officers",
      date: "August 21, 2025",
      author: "Oshoke Alasa Foundation",
      excerpt: "We visited Durumi Police Division to honor the brave men and women who dedicate their lives to keeping us safe.",
      link: "/campaigns/police-appreciation",
    },
    {
      id: 15,
      image: "/nisa/img1.jpeg",
      title: "A Day of Healing at Nisa Garki Hospital",
      date: "November 15, 2025",
      author: "Oshoke Alasa Foundation",
      excerpt: "We supported families by paying medical bills, shared heartfelt words of encouragement, and lifted spirits with prayers.",
      link: "/campaigns/nisa-hospital",
    },
  ];

  return (
    <div>
      {/* Hero Section */}
      <section className="bg-cream py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto">
            <p className="text-primary font-medium text-sm tracking-wider uppercase mb-3">OUR BLOG</p>
            <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6">
              Latest News & Stories
            </h1>
            <p className="text-gray-600 text-lg">
              Stay updated with our latest activities, stories of impact, and news from the field.
            </p>
          </div>
        </div>
      </section>

      {/* Featured Post */}
      <section className="py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to={posts[0].link} className="grid lg:grid-cols-2 gap-8 bg-white rounded-2xl overflow-hidden shadow-xl group">
            <div className="h-64 lg:h-auto overflow-hidden">
              <img
                src={posts[0].image}
                alt={posts[0].title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
              />
            </div>
            <div className="p-8 lg:p-12 flex flex-col justify-center">
              <div className="flex items-center gap-4 text-sm text-gray-500 mb-4">
                <span className="flex items-center">
                  <Calendar className="w-4 h-4 mr-2" />
                  {posts[0].date}
                </span>
                <span className="flex items-center">
                  <User className="w-4 h-4 mr-2" />
                  {posts[0].author}
                </span>
              </div>
              <h2 className="font-serif text-2xl md:text-3xl font-bold text-gray-900 mb-4 group-hover:text-primary transition-colors">
                {posts[0].title}
              </h2>
              <p className="text-gray-600 leading-relaxed mb-6">
                {posts[0].excerpt}
              </p>
              <span className="text-primary font-medium inline-flex items-center gap-2">
                Read More <ArrowRight className="w-4 h-4" />
              </span>
            </div>
          </Link>
        </div>
      </section>

      {/* Blog Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {posts.slice(1).map((post) => (
              <Link
                key={post.id}
                to={post.link}
                className="bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100 group"
              >
                <div className="h-48 overflow-hidden">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-6">
                  <div className="flex items-center text-sm text-gray-500 mb-3">
                    <Calendar className="w-4 h-4 mr-2" />
                    {post.date}
                  </div>
                  <h3 className="font-semibold text-xl text-gray-900 mb-3 group-hover:text-primary transition-colors">
                    {post.title}
                  </h3>
                  <p className="text-gray-500 text-sm leading-relaxed mb-4">
                    {post.excerpt}
                  </p>
                  <span className="text-primary font-medium text-sm inline-flex items-center gap-2">
                    Read More <ArrowRight className="w-4 h-4" />
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter */}
      <section className="py-20 bg-cream">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Subscribe to Our Newsletter
          </h2>
          <p className="text-gray-600 mb-8">
            Stay updated with our latest news, events, and stories of impact.
          </p>
          <form className="flex flex-col sm:flex-row gap-4 max-w-lg mx-auto">
            <input
              type="email"
              placeholder="Enter your email"
              className="flex-1 px-6 py-4 rounded-full border border-gray-300 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
            />
            <button
              type="submit"
              className="bg-primary hover:bg-primary-dark text-white px-8 py-4 rounded-full font-medium text-sm transition-colors"
            >
              SUBSCRIBE
            </button>
          </form>
        </div>
      </section>
    </div>
  );
};

export default Blog;
